import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import { List, ListItem } from 'material-ui/List';

import Poll from './DashboardPoll';
import ApplicationInfo from './ApplicationInfo';

import TenantShowingDialog from './todos/TenantShowingDialog';
import AmenityBookingTodo from './todos/AmenityBookingTodo';
import DocumentUploadTodoDialog from './todos/DocumentUploadTodoDialog';
import AutopayTodo from './todos/AutopayTodo';

import SurveyTodo from './todos/SurveyTodo';
import RentersInsuranceUploader from './todos/RentersInsuranceUploader';

import { getTenantTodoList } from 'actions/todoActions';
import { updateDocumentToSign } from 'actions/renewalLeaseWizardActions';
import { createTenantDocument } from 'actions/tenantProfileActions';
import { getUserPreferences } from 'actions/userTypesActions';
import { showFailure } from 'actions/notificationActions';

import { redirectToApplicationPage } from 'helpers/SignDocumentURL';
import { AccentColor } from 'helpers/AccentColorHelper';

import { localize } from 'react-localize-redux';

import EmailIcon from '@material-ui/icons/EmailTwoTone';
import PayIcon from '@material-ui/icons/PaymentTwoTone';
import ParcelIcon from '@material-ui/icons/LocalShippingTwoTone';
import ApplyIcon from '@material-ui/icons/MeetingRoomTwoTone';
import SignIcon from '@material-ui/icons/GestureTwoTone';
import UploadIcon from '@material-ui/icons/CloudUploadTwoTone';
import { deepDiver } from 'helpers/utilities';
import { getPropertyPublic } from 'actions/landlordPropertiesActions';
import { formatMoney } from 'helpers/Formatter';
import { hostIsBoardwalk } from 'helpers/CurrentWindowLocation';
import { getTranslatedString } from 'helpers/i18n';
import { featureEnabled } from 'helpers/ToggleBot';
import { colors } from 'helpers/ColorHelper';
import env from 'config/constants';
import { hellosignClient } from 'helpers/hellosignClient';
import { apiGet } from 'helpers/ApiHelper';
import Auth from 'j-toker';
import { toFriendlyDateString } from 'helpers/Formatter';

const style = {
  list_item: {
    fontSize: '15px',
    color: '#3e3e3e',
  },
  second_tier: {
    fontSize: '14px',
    color: '#6F6F6F',
    textOverflow: 'ellipsis',
  },
};

const ToDoComponent = connect(
  (store) => {
    return {
      todoData: store.todo.todoData,
      numberOfTasks: store.todo.numberOfTasks,
      tenantOverview: store.dashboard.tenantOverview,
      address: store.dashboard.address,
      leaseStartDate: store.dashboard.leaseStartDate,
      enableInsurancePurchaseInTenantApp:
        store.userTypes.userPreferences.enable_insurance_purchase_in_tenant_app,
      customPaymentLinkForTenants: store.userTypes.userPreferences.custom_payment_link_for_tenants,
      usePaymentLinkForTenants: store.userTypes.userPreferences.use_payment_link_for_tenants,
      customPaymentProviderName: store.userTypes.userPreferences.custom_payment_provider_name,
      sign_url: store.applicationStatus.sign_url,
    };
  },
  {
    getTenantTodoList,
    updateDocumentToSign,
    createTenantDocument,
    getPropertyPublic,
    getUserPreferences,
    showFailure,
  }
)(
  class ToDoComponent extends Component {
    constructor(props, context) {
      super(props, context);
      this.state = {
        componentHeight: `${props.defaultHeight}px`,
        isExpanded: false,
        payDialogOpen: false,
        paymentDetails: {},
        insuranceDialogOpen: false,
        insuranceUploaderDialogOpen: false,
      };
    }

    componentDidMount() {
      this.props.getUserPreferences();
      this.props.getTenantTodoList().then(() => {
        const showingTodo = this.props.todoData.find((todo) => todo.event_type === 'Showing');
        if (showingTodo) {
          const propertyId = deepDiver(showingTodo, 'property.property_uid');
          if (propertyId) {
            this.props.getPropertyPublic(propertyId);
          }
        }
      });
      hellosignClient.on('sign', () => {
        window.location.reload();
      });
    }

    redirectToSignPage = async (
      document_uuid,
      document_type,
      signer_uuid,
      application_uuid,
      renewal_uuid,
      use_hellosign,
      hellosign_api_app_id
    ) => {
      const custom_lease_creator_toggle = featureEnabled('custom_lease_creator');
      if (custom_lease_creator_toggle && use_hellosign) {
        let url;
        if (document_type === 'LEASE') {
          url = `${Auth.getApiUrl()}/signable_doc/sign_url?application_uuid=${application_uuid}`;
        } else if (document_type === 'LEASE_RENEWAL') {
          url = `${Auth.getApiUrl()}/signable_doc/sign_url?renewal_uuid=${renewal_uuid}`;
        }

        const { sign_url } = await apiGet(url);

        hellosignClient.open(sign_url, {
          clientId: hellosign_api_app_id,
          skipDomainVerification: env.ENV !== 'production',
        });
        return;
      }

      if (!(document_uuid && document_type && signer_uuid)) {
        return;
      }
      if (document_type === 'N2' || document_type === 'N1') {
        this.props.updateDocumentToSign({
          document_uuid,
          signer_uuid,
          document_type,
        });
        browserHistory.push('/renew_lease');
      } else {
        browserHistory.push(
          `/internal_document_portal?document_uuid=${document_uuid}&document_type=${document_type}&signer_uuid=${signer_uuid}`
        );
      }
    };

    toggleInsuranceDialog = () => {
      this.setState({ insuranceDialogOpen: !this.state.insuranceDialogOpen });
    };

    toggleOnlyInsuranceUploaderDialog = () => {
      this.setState({ insuranceUploaderDialogOpen: !this.state.insuranceUploaderDialogOpen });
    };

    render() {
      const toDoData = this.props.todoData;

      return (
        <div className="row">
          <Poll />
          {!this.props.tenantOverview.active_lease && <ApplicationInfo />}
          {toDoData.length > 0 && (
            <div className="grid-column" ref="toDoContainer" style={{ zIndex: '101' }}>
              <DocumentUploadTodoDialog
                isOpen={this.state.insuranceDialogOpen}
                toggleDialog={this.toggleInsuranceDialog}
                tenantOverview={this.props.tenantOverview}
                address={this.props.address}
                createTenantDocument={this.props.createTenantDocument}
                leaseStartDate={this.props.leaseStartDate}
                showFailure={this.props.showFailure}
              />
              <RentersInsuranceUploader
                dialogOpen={this.state.insuranceUploaderDialogOpen}
                toggleDialog={this.toggleOnlyInsuranceUploaderDialog}
                onSubmit={this.props.createTenantDocument}
              />

              <h3 style={{ margin: '15px 0' }}>
                {getTranslatedString('todo')}
                <b style={{ fontFamily: 'Circular-Black', color: AccentColor() }}>.</b>
              </h3>
              <List style={{ padding: 0 }}>{this.toDoActionItems(toDoData)}</List>
            </div>
          )}
        </div>
      );
    }

    toDoActionItems = (toDoData) => {
      let renderedCustomPayLink = false;

      return Object.keys(toDoData).map((key) => {
        switch (toDoData[key].event_type) {
          case 'Messages':
            return this.renderMessagesTodo(toDoData, key);
          case 'Pay':
            if (renderedCustomPayLink) return null;
            if (this.props.usePaymentLinkForTenants) {
              renderedCustomPayLink = true;
              return this.customPaymentLink(
                this.props.customPaymentProviderName,
                this.props.customPaymentLinkForTenants
              );
            }
            return this.renderPayTodo(toDoData, key);
          case 'OutstandingBalance':
            return this.renderOutstandingBalanceTodo(toDoData, key);
          case 'YardiLedger':
            return this.renderYardiLedgerTodo(toDoData, key);
          case 'Signature':
            return this.renderSignatureTodo(toDoData, key);
          case 'Apply':
            return this.renderApplyTodo(toDoData, key);
          case 'ApplicationDeposit':
            return this.renderApplicationDepositTodo(toDoData, key);
          case 'Showing':
            return <TenantShowingDialog key={key} showingData={toDoData[key]} />;
          case 'AmenityBooking':
            return <AmenityBookingTodo key={key} showingData={toDoData[key]} />;
          case 'DocumentUpload':
            return this.renderInsuranceUploadTodo(toDoData, key);
          case 'Autopay':
            return <AutopayTodo key={key} routeToAutopay={this.props.toggleAutopay} />;
          case 'RenewalApplication':
            return this.renderRenewalApplication(toDoData, key);
          case 'Survey':
            return (
              <SurveyTodo
                key={key}
                surveyTitle={toDoData[key].title}
                uuid={toDoData[key].uuid}
                accessUUID={toDoData[key].access_key}
              />
            );
          case 'Parcel':
            return this.renderParcelTodo(toDoData, key);
          default:
            return null;
        }
      });
    };

    renderInsuranceUploadTodo = (toDoData, key) => {
      let primaryText = getTranslatedString('todo.clickToUploadPurchaseInsurance');
      if (toDoData[key].soon_expiring) {
        primaryText = getTranslatedString('todo.clickInsuranceWillExpire');
      }
      if (!this.props.enableInsurancePurchaseInTenantApp) {
        primaryText = getTranslatedString('todo.clickToOnlyUploadInsurance');
      }
      return (
        <ListItem
          onClick={
            !this.props.enableInsurancePurchaseInTenantApp
              ? this.toggleOnlyInsuranceUploaderDialog
              : this.toggleInsuranceDialog
          }
          primaryText={<span style={{ textOverflow: 'ellipsis' }}>{primaryText}</span>}
          aria-label={primaryText}
          leftIcon={<UploadIcon style={{ color: AccentColor() }} />}
          style={style.list_item}
          key={key}
          tabIndex={1}
        />
      );
    };

    renderMessagesTodo = (toDoData, key) => {
      const primaryText = `${toDoData[key].unread_messages} ${getTranslatedString(
        'todo.unreadMessages'
      )}`;
      return (
        <ListItem
          key={key}
          style={style.list_item}
          onClick={() => {
            browserHistory.push('messaging');
          }}
          primaryText={<span>{primaryText}</span>}
          aria-label={primaryText}
          leftIcon={<EmailIcon style={{ color: AccentColor() }} />}
          tabIndex="1"
        />
      );
    };

    renderYardiLedgerTodo = (toDoData, key) => {
      // TODO Payments: combine with renderOutstandingBalanceTodo

      const ableToMakePayment =
        this.props.tenantOverview.use_payment_platform &&
        this.props.tenantOverview.payments_module_active;

      if (!ableToMakePayment) return null;
      let primaryText = getTranslatedString('todo.clickToPayForSpecificLease', {
        unitNumber: toDoData[key].unit_number,
        propertyName: toDoData[key].property_name,
      });

      return (
        <ListItem
          onClick={this.props.togglePayDialog}
          primaryText={<span>{primaryText}</span>}
          aria-label={primaryText}
          leftIcon={<PayIcon style={{ color: AccentColor() }} />}
          style={{ fontSize: '15px', color: colors.TODO_ITEM_BG }}
          key={key}
          tabIndex="1"
        />
      );
    };

    renderOutstandingBalanceTodo = (toDoData, key) => {
      // TODO Payments: combine with renderYardiLedgerTodo
      if (!hostIsBoardwalk()) return;

      let outstandingBalanceLabel = <span>{getTranslatedString('makeAPayment')}</span>;
      if (toDoData[key].outstanding_balance > 0) {
        outstandingBalanceLabel = (
          <span>
            {getTranslatedString('todo.clickToPayOutstandingBalance')}{' '}
            {formatMoney(toDoData[key].outstanding_balance)}
          </span>
        );
      }

      return (
        <ListItem
          onClick={this.props.togglePayDialog}
          primaryText={outstandingBalanceLabel}
          aria-label={outstandingBalanceLabel}
          key="todo-outstanding"
          leftIcon={<PayIcon style={{ color: AccentColor() }} />}
          style={{ fontSize: '15px', color: '#3e3e3e' }}
          tabIndex="1"
        />
      );
    };

    customPaymentLink = (provider, link) => {
      return (
        <ListItem
          component="a"
          href={link}
          target="_blank"
          primaryText={getTranslatedString('tenantPortal.customPaymentProvider', {
            provider: provider,
          })}
          aria-label={getTranslatedString('tenantPortal.customPaymentProvider', {
            provider: provider,
          })}
          key="todo-outstanding"
          leftIcon={<PayIcon style={{ color: AccentColor() }} />}
          style={{ fontSize: '15px', color: '#3e3e3e' }}
          tabIndex="1"
        />
      );
    };

    renderPayTodo = (toDoData, key) => {
      if (hostIsBoardwalk()) return;

      let primaryText = this.props.tenantOverview.use_payment_platform
        ? getTranslatedString('todo.clickToPay')
        : `${getTranslatedString('todo.clickToView')}${' '}${getTranslatedString(
            `payment_type.${toDoData[key].payment.payment_type}`
          )}${' '}${getTranslatedString('of')}${' '}${formatMoney(
            toDoData[key].payment.amount_outstanding_in_float
          )}`;

      return (
        <ListItem
          onClick={() => this.props.togglePayDialog(toDoData[key].payment)}
          primaryText={<span>{primaryText}</span>}
          aria-label={primaryText}
          leftIcon={<PayIcon style={{ color: AccentColor() }} />}
          style={{ fontSize: '15px', color: '#3e3e3e' }}
          key={key}
          tabIndex="1"
        />
      );
    };

    renderSignatureTodo = (toDoData, key) => {
      const primaryText = `${getTranslatedString('todo.clickToSign')} ${
        toDoData[key].document_type_readable
      }`;
      return (
        <ListItem
          key={key}
          onClick={() => {
            this.redirectToSignPage(
              toDoData[key].document_id,
              toDoData[key].document_type,
              toDoData[key].signer_id,
              toDoData[key].application_uuid,
              toDoData[key].renewal_uuid,
              toDoData[key].use_hellosign,
              toDoData[key].hellosign_api_app_id
            );
          }}
          primaryText={<span>{primaryText}</span>}
          aria-label={primaryText}
          leftIcon={<SignIcon style={{ color: AccentColor() }} />}
          style={style.list_item}
          tabIndex="1"
        />
      );
    };

    renderApplyTodo = (toDoData, key) => {
      const primaryText = `${getTranslatedString('todo.clickToApplyToRent')} ${
        toDoData[key].property.property_name
      }`;
      return (
        <ListItem
          key={key}
          onClick={() => {
            redirectToApplicationPage(toDoData[key].property_id, toDoData[key].application_id);
          }}
          primaryText={
            <div>
              <span>{getTranslatedString('todo.clickToApplyToRent')}</span>
              <br />
              <span style={style.second_tier}> {toDoData[key].property.property_name}</span>
            </div>
          }
          aria-label={primaryText}
          leftIcon={<ApplyIcon style={{ color: AccentColor() }} />}
          style={style.list_item}
          tabIndex="1"
        />
      );
    };

    renderApplicationDepositTodo = (toDoData, key) => {
      let primaryText = getTranslatedString('todo.clickToPayDepositForSpecificApplication', {
        unitNumber: toDoData[key].unit_number,
        propertyName: toDoData[key].property_name,
      });

      if (!toDoData[key].unit_number) {
        primaryText = getTranslatedString('todo.clickToPayDepositForSpecificApplicationNoUnit', {
          propertyName: toDoData[key].property_name,
        });
      }

      return (
        <ListItem
          onClick={() => this.props.togglePayDialog(toDoData[key])}
          primaryText={<span>{primaryText}</span>}
          aria-label={primaryText}
          leftIcon={<PayIcon style={{ color: AccentColor() }} />}
          style={{ fontSize: '15px', color: colors.TODO_ITEM_BG }}
          key={key}
          tabIndex="1"
        />
      );
    };

    renderParcelTodo = (toDoData, key) => {
      const primaryText = `${getTranslatedString('todo.parcelToPickup')} (${toDoData[
        key
      ].uuid.toUpperCase()}) ${toDoData[key].notes}`;
      return (
        <ListItem
          key={key}
          primaryText={
            <Fragment>
              <span>
                {getTranslatedString('todo.parcelToPickup')} ({toDoData[key].uuid.toUpperCase()})
              </span>
              <span style={style.second_tier}> {toDoData[key].notes}</span>
            </Fragment>
          }
          aria-label={primaryText}
          leftIcon={<ParcelIcon style={{ color: AccentColor() }} />}
          style={style.list_item}
          tabIndex="1"
        />
      );
    };

    renderRenewalApplication = (toDoData, key) => {
      let primaryText = getTranslatedString('todo.renewalApplication', {
        date: toFriendlyDateString(toDoData[key].actionable_date),
      });

      return (
        <ListItem
          onClick={() => {
            redirectToApplicationPage(
              toDoData[key].property_id,
              toDoData[key].application_id,
              toDoData[key].renewal_id
            );
          }}
          primaryText={<span>{primaryText}</span>}
          aria-label={primaryText}
          leftIcon={<PayIcon style={{ color: AccentColor() }} />}
          style={style.list_item}
          tabIndex="1"
        />
      );
    };
  }
);

export default localize()(ToDoComponent);
